import { clsx } from 'clsx';
import * as styles from './styles.css';

interface IBlockProps {
  children: React.ReactNode;
  gap?: number;
  withoutMarginBottom?: boolean;
}

export const Block: React.FC<IBlockProps> = ({ children, gap, withoutMarginBottom = false }) => {
  return (
    <div
      className={clsx(styles['container'], withoutMarginBottom && styles['disable-margin-bottom'])}
      style={gap ? { gap: `${gap}px` } : {}}
    >
      {children}
    </div>
  );
};
